/**
 */
export enum InteractionEvents {
  /**
   * Fired when a pointer device button (usually a mouse left-button) is pressed and
   * released on the display object. DisplayObject's interactive property must be set
   * to true to fire event.
   */
  Click = "click",
  /**
   * Fired when a pointer device button (usually a mouse left-button) is pressed on the
   * display. object. DisplayObject's interactive property must be set to true to fire event.
   */
  MouseDown = "mousedown",
  /**
   * Fired when a pointer device (usually a mouse) is moved while over the display object.
   * DisplayObject's interactive property must be set to true to fire event.
   */
  MouseMove = "mousemove",
  /**
   * Fired when a pointer device (usually a mouse) is moved off the display object.
   * DisplayObject's interactive property must be set to true to fire event.
   */
  MouseOut = "mouseout",
  /**
   * Fired when a pointer device (usually a mouse) is moved onto the display object.
   * DisplayObject's interactive property must be set to true to fire event.
   */
  MouseOver = "mouseover",
  /**
   * Fired when a pointer device button (usually a mouse left-button) is released over the
   * display object. DisplayObject's interactive property must be set to true to fire event.
   */
  MouseUp = "mouseup",
  /**
   * Fired when a pointer device button (usually a mouse left-button) is released outside
   * the display object that initially registered a mousedown. DisplayObject's interactive
   * property must be set to true to fire event.
   */
  MouseUpOutside = "mouseupoutside",
  /**
   * Fired when the operating system cancels a pointer event. DisplayObject's interactive
   * property must be set to true to fire event.
   */
  PointerCancel = "pointercancel",
  /**
   * Fired when a pointer device button is pressed on the display object. DisplayObject's
   * interactive property must be set to true to fire event.
   */
  PointerDown = "pointerdown",
  /**
   * Fired when a pointer device is moved while over the display object. DisplayObject's
   * interactive property must be set to true to fire event.
   */
  PointerMove = "pointermove",
  /**
   * Fired when a pointer device is moved off the display object. DisplayObject's interactive
   * property must be set to true to fire event.
   */
  PointerOut = "pointerout",
  /**
   * Fired when a pointer device is moved onto the display object. DisplayObject's interactive
   * property must be set to true to fire event.
   */
  PointerOver = "pointerover",
  /**
   * Fired when a pointer device button is pressed and released on the display object.
   * DisplayObject's interactive property must be set to true to fire event.
   */
  PointerTap = "pointertap",
  /**
   * Fired when a pointer device button is released over the display object. DisplayObject's
   * interactive property must be set to true to fire event.
   */
  PointerUp = "pointerup",
  /**
   * Fired when a pointer device button is released outside the display object that initially
   * registered a pointerdown. DisplayObject's interactive property must be set to true to fire event.
   */
  PointerUpOutside = "pointerupoutside",
  /**
   * Fired when a pointer device secondary button (usually a mouse right-button) is pressed and
   * released on the display object. DisplayObject's interactive property must be set to true
   * to fire event.
   */
  RightClick = "rightclick",
  /**
   * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
   * on the display object. DisplayObject's interactive property must be set to true to fire event.
   */
  RightDown = "rightdown",
  /**
   * Fired when a pointer device secondary button (usually a mouse right-button) is released
   * over the display object. DisplayObject's interactive property must be set to true to fire event.
   */
  RightUp = "rightup",
  /**
   * Fired when a pointer device secondary button (usually a mouse right-button) is released
   * outside the display object that initially registered a rightdown. DisplayObject's
   * interactive property must be set to true to fire event.
   */
  RightUpOutside = "rightupoutside",
  /**
   * Fired when a touch point is placed and removed from the display object. DisplayObject's
   * interactive property must be set to true to fire event.
   */
  Tap = "tap",
  /**
   * Fired when the operating system cancels a touch. DisplayObject's interactive property
   * must be set to true to fire event.
   */
  TouchCancel = "touchcancel",
  /**
   * Fired when a touch point is removed from the display object. DisplayObject's interactive
   * property must be set to true to fire event.
   */
  TouchEnd = "touchend",
  /**
   * Fired when a touch point is removed outside of the display object that initially registered
   * a touchstart. DisplayObject's interactive property must be set to true to fire event.
   */
  TouchEndOutside = "touchendoutside",
  /**
   * Fired when a touch point is moved along the display object. DisplayObject's interactive
   * property must be set to true to fire event.
   */
  TouchMove = "touchmove",
  /**
   * Fired when a touch point is placed on the display object. DisplayObject's interactive
   * property must be set to true to fire event.
   */
  TouchStart = "touchstart"
}
